import { cellValueExcel } from "types";

export function numberFormat(value: number): cellValueExcel {
  return {
    text: value,
    style: {
      alignment: { horizontal: "right" },
      numFmt: "#,##0"
    }
  }
}